import React from "react";
import { BreadcrumbGroup } from "@cloudscape-design/components";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "../../../hooks/useBreadcrumbs";
import "./breadcrumb.scss";

const Breadcrumb: React.FC = () => {
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbs();

  const handleFollow = (event: any) => {
    event.preventDefault();
    const href = event.detail.href;
    if (href && href.startsWith("/")) {
      navigate(href);
    }
  };

  // Don't render breadcrumbs if there's only one item (just Dashboard)
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <div className="breadcrumb-container">
      <BreadcrumbGroup
        items={breadcrumbs}
        onFollow={handleFollow}
        ariaLabel="Breadcrumb navigation"
      />
    </div>
  );
};

export default Breadcrumb;
